import ContentLoader from 'react-content-loader'

import theme from 'theme_'

function DomainBreadcrumbsLoader() {
  return (
    <ContentLoader
      speed={2}
      width={560}
      height={40}
      viewBox="0 0 560 40"
      backgroundColor={theme.colors.newLightGrey}
      foregroundColor={theme.colors.lightGrey}
    >
      <rect x="0" y="0" rx="8" ry="8" width="160" height="40" />
      <rect x="200" y="0" rx="8" ry="8" width="160" height="40" />
      <rect x="400" y="0" rx="8" ry="8" width="160" height="40" />
    </ContentLoader>
  )
}

export default DomainBreadcrumbsLoader
